import styled from "styled-components"
import CustomTooltip from "./ToolTip"

const Tooltip = styled(CustomTooltip)`
  &.ant-tooltip {
    .ant-tooltip-inner {
      border-radius: 2px;
      font-size: 14px;
      background-color: ${(props) => props.theme.bgcolordblack};
      color: ${(props) => props.theme.textcolorwhite};
    }
    .ant-tooltip-arrow {
      &::before {
        background-color: ${(props) => props.theme.bgcolordblack};
      }
    }
  }
`

export default Tooltip
